export default __webpack_public_path__ + "static/csr-2cbe79b5cabd8aef064e2581d4a57f1e.png";